import { QueryError } from '@graphql-box/helpers';

import { useQuery } from '@graphql-box/react';
import { useTheme } from '@mui/material';
import { useEffect } from 'react';
import { deriveSeasonRibbonColor } from '../helpers/deriveRibbonColor.ts';
import { deriveSeasonRibbonMessage } from '../helpers/deriveSeasonRibbonMessage.ts';
import { isSeasonRibbonWithinTimeframe } from '../helpers/isRibbonWithinTimeframe.ts';
import { Ribbon } from '../styled.ts';
import { type RibbonSeasonDetailsData, type SeasonRibbonProps } from '../types.ts';

const GET_RIBBON_SEASON_DETAILS = "query GetRibbonSeasonDetails(\n  $id: ID!\n) {\n  season(id: $id) {\n    airDate\n    episodes {\n      airDate\n    }\n  }\n}\n";

export const SeasonRibbon = ({ id, sx }: SeasonRibbonProps) => {
  const theme = useTheme();

  const { execute, result } = useQuery<RibbonSeasonDetailsData>(GET_RIBBON_SEASON_DETAILS, {
    loading: true,
  });

  useEffect(() => {
    void execute({ variables: { id } }, { data: { initiator: 'SeasonRibbon' } });
    // We only want to re-execute when id changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (result instanceof QueryError) {
    console.error(result);
    return;
  }

  if (result?.errors?.length) {
    console.error(result.errors);
  }

  if (!result?.data || !isSeasonRibbonWithinTimeframe(result.data.season)) {
    return;
  }

  return (
    <Ribbon ribbonColor={deriveSeasonRibbonColor(result.data.season, theme)} sx={sx}>
      <span>{deriveSeasonRibbonMessage(result.data.season)}</span>
    </Ribbon>
  );
};
